import React, { Component, ContextType } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '../../Context/appContext';
// import Modal from 'react-modal';
import './footer.css';
import vmLogoTriad from '../..//static/img/vm/vm-logo-triad.svg';
import paia from '../../static/Vinimark Website PAIA manual.pdf';
import privacy from '../../static/Vinimark Website Privacy Policy.pdf';

class Footer extends Component<{}, {}> {
  static contextType = AppContext;
  context!: ContextType<typeof AppContext>;

  render() {
    return (
      <footer>
          <div style={{display: 'flex', flexDirection: window.innerWidth < 768 ? 'column' : 'row', width: '100%', marginBottom: '-50px'}}>
              <div style={{display: 'flex', flex: 4}}>
                  <div style={{flex: 9}}>
                      <div className="footer-item footer-item-copyright">
                          <div className="footer-item-inner" >
                              <p style={{fontSize: '10px !important', fontWeight: 600, marginBottom: 0, marginTop: 0, lineHeight: '13px'}} className='footer-text'>&copy; {new Date().getFullYear()} All rights reserved.
                                  {window.innerWidth < 768 ? <><br />Vinimark is a registered trademark.</> : ' Vinimark is a registered trademark.'}
                              </p>
                              <p style={{fontSize: '10px !important', fontWeight: 600, marginBottom: 0, marginTop: 0, lineHeight: '13px'}} className='footer-text'>Not for sale to persons under the age of 18.&nbsp;<a style={{textDecoration: 'underline'}} href="https://www.aware.org.za/" target="_blank"> Aware.org</a></p>
                          </div>
                      </div>
                  </div>
                  <div style={{flex: 1}}>
                      <div className="footer-item footer-item-logo">
                          <Link to="/"><img src={vmLogoTriad} alt="VM Logo" /></Link>
                      </div>
                  </div>
              </div>
              <div style={{flex: 6}}>
                  <div className="footer-item footer-item-links">
                      <ul className="footer-links footer-links-business" style={{ marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0}}>
                          <li><Link style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0}} to="/subscribe"><span style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0}}>Subscribe</span></Link></li>
                          <li><Link style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0}} to="/terms"><span style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0}}>Terms of Use</span></Link></li>
                          <li><Link style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0}} to="/terms-of-sales"><span style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0}}>Terms of Sale</span></Link></li>
                          <li>
                              <a
                                  href={privacy}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0 }}
                              >
    <span style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0 }}>
      Privacy Policy
    </span>
                              </a>
                          </li>
                          <li>
                              <a
                                  href={paia}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0 }}
                              >
    <span style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0 }}>
      PAIA Manual
    </span>
                              </a>
                          </li>
                          <li><Link style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0}} to="/customer-login"><span style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0}}>Login</span></Link></li>
                          <li><Link style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0}} to="/contact"><span style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0}}>Contact</span></Link></li>
                      </ul>

                      <ul className="footer-links footer-links-social" style={{ marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0}}>
                          <li ><a style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0}} href="https://www.linkedin.com/company/vinimark-the-wine-company/" target="_blank" rel="noopener noreferrer"><span style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0}}>Linkedin</span></a></li>
                          <li><a style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0}} href="https://www.instagram.com/vinimarkwine/" target="_blank" rel="noopener noreferrer"><span style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0}}>Instagram</span></a></li>
                          <li><a style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0}} href="https://x.com/VinimarkWine" target="_blank" rel="noopener noreferrer"><span style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0}}>X.com</span></a></li>
                          <li><a style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0}} href="https://www.facebook.com/VinimarkWine" target="_blank" rel="noopener noreferrer"><span style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0}}>Facebook</span></a></li>
                          <li><a style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0}} href="https://open.spotify.com/show/6TVkRApHVsQywJYHPpcIpe" target="_blank" rel="noopener noreferrer"><span style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0}}>Spotify</span></a></li>
                          <li><a style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0}} href="https://optimalonline.co.za/" target="_blank" rel="noopener noreferrer"><span style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0}}>Powered by Optimal Online</span></a></li>
                      </ul>
                  </div>
              </div>
          </div>





      </footer>
    );
  }
}

export default Footer;
